/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordayslabel3Inputs */

const en_menueditordayslabel3 = /** @type {(inputs: Menueditordayslabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekdays`)
};

const de_menueditordayslabel3 = /** @type {(inputs: Menueditordayslabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochentage`)
};

/**
* | output |
* | --- |
* | "Weekdays" |
*
* @param {Menueditordayslabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordayslabel3 = /** @type {((inputs?: Menueditordayslabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordayslabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordayslabel3(inputs)
	return de_menueditordayslabel3(inputs)
});
export { menueditordayslabel3 as "menuEditorDaysLabel" }